import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { LollyBaseService } from "./lolly-base-services/lolly-base.service";

@Injectable({
	providedIn: "root",
})
export class LawpayService extends LollyBaseService {
	constructor(public provider: ServiceProvider) {
		super("api/account/lawpay", provider);
	}
	verifyReCaptcha(data) {
		return this.save(data, `/portal/onelink/verify/recaptcha`);
	}
}
